import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import times from 'lodash/times';
import qs from 'qs';

import SubList from 'components/SubList';
import SearchSubsForm from 'components/SearchSubsForm';

class TracfoneSearchSubs extends Component {
  state = {
    selected: [],
    loading: false,
  };

  componentDidMount() {
    const { location } = this.props;
    const { user_profile } = location
      ? qs.parse(location.search, { ignoreQueryPrefix: true })
      : '';

    if (user_profile) {
      this.handleSearchSubs({ user_profile });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.page !== this.props.page) {
      this.setState({
        selected: [],
        allCheckbox: false,
      });
    }
  }

  handleSearchSubs = (values) => {
    const { searchSubs, page } = this.props;
    this.setState({
      selected: [],
    });
    return searchSubs(page, values);
  };

  render() {
    const {
      subs,
      pageCount,
      page,
      pageRoute,
      subscriptionRoute,
      location,
      isSprintSubsSearch = false,
    } = this.props;
    const { selected } = this.state;
    const { user_profile } = location
      ? qs.parse(location.search, { ignoreQueryPrefix: true })
      : '';

    const initialValues = { user_profile };

    return (
      <div className="tracfone-search">
        <h1>Search Subscriptions</h1>
        <SearchSubsForm
          initialValues={initialValues}
          isSprintSubsSearch={isSprintSubsSearch}
          onSubmit={this.handleSearchSubs}
        />
        <br />
        {subs && subs.length > 0 && (
          <SubList
            subs={subs}
            viewUrl={subscriptionRoute}
            selectedSubs={selected}
          />
        )}
        {subs && subs.length === 0 && <div>No results</div>}
        <nav aria-label="Page navigation">
          <ul className="pagination">
            {pageCount > 1 &&
              times(pageCount, (pageNum) => {
                pageNum += 1;
                return (
                  <li
                    key={pageNum}
                    className={pageNum === parseInt(page, 10) ? 'active' : ''}
                  >
                    <Link to={pageRoute(pageNum)}>{pageNum}</Link>
                  </li>
                );
              })}
          </ul>
        </nav>
      </div>
    );
  }
}

export default TracfoneSearchSubs;
